import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { ASSETS, waLink, CONTACT_PHONE } from "@/lib/site";
import { ShieldCheck, Globe2, Plane, HeartHandshake } from "lucide-react";

export function SiteFooter() {
  const { t } = useApp();
  const trust = [
    { icon: ShieldCheck, text: { tr: "Ruhsatlı sağlık kuruluşu", en: "Licensed healthcare facility" } },
    { icon: Globe2, text: { tr: "Uluslararası hasta koordinasyonu", en: "International patient coordination" } },
    { icon: Plane, text: { tr: "Havaalanı karşılama ve transfer", en: "Airport pickup and transfers" } },
    { icon: HeartHandshake, text: { tr: "Tedavi sonrası takip", en: "Aftercare follow-up" } },
  ];
  const cols = [
    {
      title: { tr: "Tedaviler", en: "Treatments" },
      links: [
        { to: "/tedaviler/dis", label: { tr: "Diş Tedavileri", en: "Dental Treatments" } },
        { to: "/tedaviler/zirkonyum", label: { tr: "Zirkonyum Gülüş Tasarımı", en: "Zirconium Smile Design" } },
        { to: "/tedaviler", label: { tr: "Diğer Alanlar", en: "Other Areas" } },
      ],
    },
    {
      title: { tr: "Klinik", en: "Clinic" },
      links: [
        { to: "/klinik", label: { tr: "Kliniğimiz", en: "Our Clinic" } },
        { to: "/hekimler", label: { tr: "Hekimlerimiz", en: "Our Doctors" } },
        { to: "/sonuclar", label: { tr: "Sonuçlar", en: "Results" } },
        { to: "/yolculuk", label: { tr: "Hasta Yolculuğu", en: "Patient Journey" } },
      ],
    },
    {
      title: { tr: "Yasal", en: "Legal" },
      links: [
        { to: "/kvkk", label: { tr: "KVKK Aydınlatma Metni", en: "KVKK Notice" } },
        { to: "/gizlilik", label: { tr: "Gizlilik Politikası", en: "Privacy Policy" } },
        { to: "/cerez", label: { tr: "Çerez Politikası", en: "Cookie Policy" } },
        { to: "/kullanim-kosullari", label: { tr: "Kullanım Koşulları", en: "Terms of Use" } },
      ],
    },
  ];

  return (
    <footer className="bg-[#0A0E14] text-white/80 mt-24 border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pb-12 border-b border-white/10">
          {trust.map((it, i) => (
            <div key={i} className="flex items-start gap-3">
              <it.icon size={20} className="text-[var(--accent-2)] shrink-0 mt-0.5" />
              <span className="text-sm">{t(it.text)}</span>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-4 gap-10 py-12">
          <div>
            <img src={ASSETS.logoWhite} alt="Zeta Clinic" className="h-20 w-auto object-contain -ml-2" loading="lazy" />
            <p className="text-sm leading-relaxed mt-3 text-white/60">
              {t({
                tr: "İstanbul merkezli uluslararası sağlık turizmi markası. Dijital gülüş tasarımı ve kişiye özel zirkonyum tedavisi.",
                en: "Istanbul-based international health tourism brand. Digital smile design and personalised zirconium treatment.",
              })}
            </p>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="inline-block mt-4 text-sm font-semibold text-[var(--accent-2)] hover:underline">
              WhatsApp: {CONTACT_PHONE}
            </a>
          </div>
          {cols.map((c, i) => (
            <div key={i}>
              <h3 className="text-sm font-semibold text-white mb-4">{t(c.title)}</h3>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to + t(l.label)}>
                    <Link to={l.to} className="text-sm text-white/60 hover:text-white transition-colors">
                      {t(l.label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-white/50">
          <p data-testid="footer-license">
            {t({
              tr: "T.C. Sağlık Bakanlığı Sağlık Turizmi Yetki Belgesi No: [Belge no eklenecek] · Zeta Clinic, İstanbul",
              en: "Republic of Türkiye Ministry of Health — Health Tourism Authorisation No: [to be added] · Zeta Clinic, Istanbul",
            })}
          </p>
          <p>© {new Date().getFullYear()} Zeta Clinic</p>
        </div>
        <p className="mt-4 text-[11px] text-white/40 max-w-3xl">
          {t({
            tr: "Bu web sitesindeki içerikler bilgilendirme amaçlıdır; tanı koymaz ve tedavi sonucu garanti etmez. Nihai değerlendirme hekim tarafından yapılır.",
            en: "Content on this website is for information only; it does not diagnose and does not guarantee treatment outcomes. The final assessment is made by the physician.",
          })}
        </p>
      </div>
    </footer>
  );
}
